///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/s/basket.js
///include /assets/js/app/p/brand.js
///include /assets/js/app/p/description-template-compiler.js

"use strict"

class SOrderWordpressHostingPage {
    init() {
        this.view = new Vue({
            el: ".vue-wrapper",
            name: "order-wordpress",
            data() {
                const vue = this
                return {
                    /** @type {SBasket} */
                    ///@ts-ignore
                    basket: AnyBasket.inst,
                    brand: null,
                    catalogue: UserCatalogue.inst,
                    format: Site.Format,
                    settings: SharedSettings.inst,
                    selectedPeriod: null,
                    /** @type {boolean} */
                    productsReady: false,

                    get contact() {
                        return this.settings.contact
                    },
                    get loading() {
                        return !(
                            this.brand &&
                            this.catalogue.products &&
                            this.catalogue.isOpen !== null &&
                            vue.productsReady
                        )
                    },
                    get notHiddenWordpressProducts() {
                        return this.wordpressProducts.filter(hp => !hp.hidden)
                    },
                    /**
                     * @type {SBHostingProduct[]}
                     */
                    get products() {
                        if(this.catalogue.products) {
                            //@ts-ignore
                            return this.catalogue.products.filter(
                                p => p instanceof SBStackUserPackageAllowanceProduct && p.forSale && p.platform
                            )
                        } else {
                            return []
                        }
                    },
                    get wordpressProducts() {
                        return this.products.filter(
                            p => p.platform == "wordpress"
                        )
                    },
                }
            },
            methods: {
                //@ts-ignore
                async loadProducts() {
                    await this.catalogue.assertExists()
                    const products = await this.catalogue.preloadSingle("products")
                    await Promise.all(
                        //@ts-ignore
                        (products || [])
                            .filter(p => p instanceof SBStackUserPackageAllowanceProduct)
                            .flatMap(p => [p.preloadSingle("platform"), p.preloadSingle("limits")])
                    )
                    this.productsReady = true
                },
                bestSelectPeriod(pricing){
                    var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                    if( period && pricing.some( p=> p.periodMonths == period ) ){
                        var p = pricing.find( p=> p.periodMonths == period );
                        return p.periodMonths;
                    } else {
                        return pricing[0].periodMonths;
                    }

                },
                compiledDescription(hp, lang = "en-GB") {
                    if( this.catalogue.prefs && this.catalogue.prefs.preferGB ){
                        Site.Format.preferGB = true;
                    }
                    var template = this.catalogue.productDescriptionFromCode(hp.code, translation.getActiveLanguage()) || "{{limits.compiledTable}}";
                    console.log(template)
                var limitsInUse = hp.limits ? Object.assign(hp.limits,{display:{}}) : {display:{}};
                    if( hp.limits ){
                        /**
                         * Decoupled for translation needs
                         * Converted to if statements for better readability...
                         */

                        /** Mailboxes template */
                        if(twigExtender.limit(hp.limits.mailboxes) === Infinity) {
                            limitsInUse.display.mailboxes = translation.sprintf(
                                translation.get(`group_template_unlimited_x_mailboxes`),
                                [Site.Format.GBorMB(hp.limits.maxMailboxSize * 2 ** 20)])
                        } else {
                            limitsInUse.display.mailboxes = translation.sprintf(
                                translation.get(`group_template_mailboxes_x_megabytes_mailboxes`),
                                [
                                    Site.Format.number(twigExtender.limit(hp.limits.mailboxes)),
                                    Site.Format.GBorMB(hp.limits.maxMailboxSize * 2 ** 20)
                                ]
                            )
                        }
                        /** Mailboxes template */

                        /** Domain template */
                        if(hp.limits.domains) {
                            if((twigExtender.limit(hp.limits.domains)+1) === Infinity) {
                                limitsInUse.display.domains = translation.get(`group_template_unlimited_domains`)
                            } else {
                                limitsInUse.display.domains = translation.sprintf(
                                    translation.get(`group_template_number_more_than_1_domains`),
                                    [Site.Format.number(twigExtender.limit(hp.limits.domains)+1)]
                                )
                            }
                        } else {
                            limitsInUse.display.domains = translation.get(`group_domain_description_1_domain`)
                        }
                        /** Domain template */

                        /** Web Space template */
                        if(twigExtender.limit(hp.limits.webspace) === Infinity) {
                            limitsInUse.display.webspace = translation.get(`group_template_unlimited_ssd`)
                        } else {
                            limitsInUse.display.webspace = translation.sprintf(
                                translation.get(`group_template_megabytes_ssd_web_space`),
                                [Site.Format.GBorMB(twigExtender.limit(hp.limits.webspace) * 2 ** 20)]
                            )
                        }
                        /** Web Space template */

                        /** Bandwith template */
                        if(twigExtender.limit(hp.limits.bandwidth) === Infinity) {
                            limitsInUse.display.bandwidth = translation.get(`group_template_unlimited_bandwidth`)
                        } else {
                            limitsInUse.display.bandwidth = translation.sprintf(
                                translation.get(`group_template_megabytes_month_bandwidth`),
                                [Site.Format.GBorMB(hp.limits.bandwidth * 2 ** 20)]
                            )
                        }
                        /** Bandwith template */

                        /** MySQL template */
                        limitsInUse.display.mysqlDatabases = translation.sprintf(
                            translation.get(`group_template_number_x_mysql_database`),
                            [Site.Format.number(twigExtender.limit(hp.limits.mysqlDatabases))]
                        )
                        /** MySQL template */

                        var t = Twig.twig({data: DefaultTemplateCompiler.getTemplateByType('package', translation.getActiveLanguage()), rethrow: true });
                        limitsInUse.compiledTable = t.render( Object.assign(twigExtender, {limits:limitsInUse,hp:hp}) );
                    }
                    var result = DefaultTemplateCompiler.compile(template,{limits:limitsInUse,hp:hp});
                    return result;
                },

                /**
                 * @param {number} m
                 * @returns {string}
                 */
                intervalMonthsLabel(m) {
                    if( m == 1 ){
                        return translation.get('order_wordpress_hosting_per_month');
                    }
                    return Catalogue.intervalMonthsLabel(m)
                },
                /**
                 * @param {number | "INF" | null} v
                 * @returns {number | null}
                 */
                limit(v) {
                    if(v == "INF") {
                        return Infinity
                    } else {
                        return v
                    }
                },
                monthLabel(pricing) {
                    var period = +(
                        this.selectedPeriod ||
                        (this.catalogue.prefs?.advertiseMonthlyEquivalent ? 1 : null) ||
                        (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1
                    );
                    if (this.catalogue.prefs?.advertiseMonthlyEquivalent) {
                        return this.intervalMonthsLabel(1);
                    } else if( period && pricing.some( p=> p.periodMonths == period ) ){
                        var p = pricing.find( p=> p.periodMonths == period );
                        return this.intervalMonthsLabel(p.periodMonths);
                    } else {
                        return this.intervalMonthsLabel(pricing[0].periodMonths);
                    }
                },
                minorPrice(pricing) {
                    if (this.catalogue.prefs && this.catalogue.prefs.advertiseMonthlyEquivalent){
                        let price = pricing.map((p) => {
                          return p.price / (p.periodMonths == 0 ? 1 : p.periodMonths);
                        }).sort( (a, b) => {
                          return a - b;
                        })[0];
                        return this.format.priceTail(price, this.catalogue.currency);
                    } else {
                        var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                        if( period && pricing.some( p=> p.periodMonths == period ) ){
                            var p = pricing.find( p=> p.periodMonths == period );
                            return this.format.priceTail(p.price, this.catalogue.currency)
                        } else {
                            return this.format.priceTail(pricing[0].price, this.catalogue.currency)
                        }
                    }
                },
                majorPrice(pricing) {
                    if (this.catalogue.prefs && this.catalogue.prefs.advertiseMonthlyEquivalent){
                        let price = pricing.map((p) => {
                          return p.price / (p.periodMonths == 0 ? 1 : p.periodMonths);
                        }).sort( (a, b) => {
                          return a - b;
                        })[0];
                        return this.format.priceMajor(price, this.catalogue.currency);
                    } else {
                        var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                        if( period && pricing.some( p=> p.periodMonths == period ) ){
                            var p = pricing.find( p=> p.periodMonths == period );
                            return this.format.priceMajor(p.price, this.catalogue.currency)
                        } else {
                            return this.format.priceMajor(pricing[0].price, this.catalogue.currency)
                        }
                    }
                }
            },
            components: {
                shopNav: ShopNav,
            },
            mounted() {
                this.loadProducts()
            },
        })
    }
}
